/**
 * tabbed-content
 */

import $ from 'jquery';

// Module dependencies
import 'protons';

// Module template
import './_tabbed-content.twig';
import './_tabbed-content.css';

export const name = 'tabbed-content';

export const defaults = {
  dummyClass: 'js-tabbed-content-exists',
};

/**
 * Components may need to run clean-up tasks if they are removed from DOM.
 *
 * @param {jQuery} $context - A piece of DOM
 * @param {Object} settings - Pertinent settings
 */
// eslint-disable-next-line no-unused-vars
export function disable($context, settings) {}

/**
 * Each component has a chance to run when its enable function is called. It is
 * given a piece of DOM ($context) and a settings object. We destructure our
 * component key off the settings object and provide an empty object fallback.
 * Incoming settings override default settings via Object.assign().
 *
 * @param {jQuery} $context - A piece of DOM
 * @param {Object} settings - Settings object
 */
export function enable($context, { tabbedContent = {} }) {
  // Find our component within the DOM.
  // eslint-disable-next-line no-undef
  const tabbedContents = once(
    'tabbed-content--init',
    '.tabbed-content',
    $context
  );

  // Bail if component does not exist
  if (!tabbedContents.length) {
    return;
  }

  const $tabbedContent = $(tabbedContents);

  // Merge defaults with incoming settings
  const settings = {
    ...defaults,
    ...tabbedContent,
  };
  // An example of what could be done with this component
  $tabbedContent.addClass(settings.dummyClass);
  $tabbedContent.each(function initializeTabbedContent() {
    const tabs = $('.tabbed-content__tab', this).click(function handleTabClick(
      e
    ) {
      e.preventDefault();
      tabs.removeClass('tabbed-content__tab--active');
      $(this).addClass('tabbed-content__tab--active');
    });
  });
}

export default enable;
